import React, { Fragment } from 'react';
import Link from 'next/link';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import { getTariffs, getBanners } from '~/src/api/internet';
import { setTariffsForInternet, setBannerForInternet } from '~/src/store/actions/internet';
import BonusMobTv from '~/src/components/sections/BonusMobTv';
import CallToActionBlock from '~/src/components/sections/CallToActionBlock';
import Extra from '~/src/components/sections/Extra';
import Promo from '~/src/components/sections/Promo';
import Banner from '~/src/components/Banners/Banner';
import QuizBlock from '~/src/components/QuizBlock';
import QuizGame from '~/src/components/QuizGame';
import TariffList from './TariffList';
import { Title } from './TariffList/styled';
import {
    Wrapper,
    Container,
    PromoSubtitle,
    BannerSection,
    QuizSection,
    TariffMenu,
    TitleContainer
} from './styled';

const itemsCallToActionText = [
    'Заполните форму и оставьте заявку на сайте.',
    'С вами свяжется менеджер и поможет подобрать тариф.',
    'В удобное вам время техник оформит договор, проведет кабель и настроит оборудование.'
];

class Internet extends React.Component {

    onBannerClick = ({ clickType }) => {
        dataLayerPush({
            'event': 'UAevent',
            'category': 'banner',
            'action': `click banner to ${clickType === 'clickOnBanner' ? 'req full' : 'req'}`,
            'label': window.location.pathname,
        });

        window.location.href = this.props.banner.link;
    }

    render() {

        const {
            pageContent,
            banner,
            title,
            cityDomain,
            cityIn,
            questions,
            isQuizGame,
            isVillage,
            tariffs,
        } = this.props;

        const apartmentTariffs = tariffs.filter(item => item.is_cottage === 0);
        const cottageTariffs = tariffs.filter(item => item.is_cottage > 0);
        const hasVillageTariffs = !!((apartmentTariffs.length && cottageTariffs.length));

        const tabFlat = 'Для квартиры';
        const tabVillage = 'Для частного дома';

        const menuItems = [
            { route: '/internet', text: tabFlat },
            { route: '/internet/mono-village', params: { type: 'mono-village' }, text: tabVillage }
        ];
        const activeMenuItem = isVillage ? 1 : 0;

        const filteredTariffs = !hasVillageTariffs
            ? tariffs
            : isVillage ? cottageTariffs : apartmentTariffs;

        return (
            <Fragment>
                <Wrapper>
                    <TitleContainer>
                        <Title id='internet_title'>
                            {title}
                        </Title>
                        {
                            hasVillageTariffs &&
                            <TariffMenu items={menuItems} activeItem={activeMenuItem}/>
                        }
                    </TitleContainer>
                    <TariffList tariffs={filteredTariffs}/>

                    {
                        !isVillage && (
                            (questions && questions.length > 0) &&
                            isQuizGame
                                ? <QuizGame marginBottom='20px'/>
                                : <QuizSection>
                                    <Container>
                                        <QuizBlock />
                                    </Container>
                                </QuizSection>
                        )
                    }

                    <Container>
                        {
                            banner.id &&
                            <BannerSection>
                                <Banner
                                    onClickHandler={this.onBannerClick}
                                    banner={banner}
                                    titleTag='p'
                                />
                            </BannerSection>
                        }
                        <CallToActionBlock
                            title='Подключить интернет'
                            itemsCallToActionText={itemsCallToActionText}
                            productId='5'
                        />
                        <BonusMobTv titleTag='p' />
                        <Promo pageContent={pageContent} isVillage={isVillage} columns={2}>
                            {
                                !isVillage
                                ? <PromoSubtitle>
                                    Скорость интернета от 100 Мбит/с и выше по выгодной цене. <br/>
                                    <Link href='/request?clear=true'>Оставьте заявку</Link>, чтобы подключить интернет
                                    в {cityIn}.
                                  </PromoSubtitle>
                                : <PromoSubtitle>
                                    <Link href='/request?clear=true'>Оставьте заявку</Link>, чтобы подключить интернет от 100 Мбит/с и выше в частном доме по выгодной цене.
                                  </PromoSubtitle>
                            }
                        </Promo>
                        <Extra isVillage={isVillage} pageContent={pageContent} cityIn={cityIn} cityDomain={cityDomain}/>
                    </Container>
                </Wrapper>
            </Fragment>
        );
    }

    componentDidMount() {

        const { cityDomain, isAuth, setTariffsForInternet, setBannerForInternet } = this.props;

        if (isAuth) {

            getTariffs(cityDomain, isAuth).then(data => {

                const tariffs = data.data.items;

                setTariffsForInternet(tariffs);

            }).catch(e => console.log(e));

            getBanners(cityDomain, isAuth).then(data => {

                const bannerData = data.data.items[0].bannerInfo;

                setBannerForInternet(bannerData);

            }).catch(e => console.log(e));
        }
    }
}

Internet.propTypes = {
    pageContent: PropTypes.object,
    cityIn: PropTypes.string,
    banner: PropTypes.object,
    cityDomain: PropTypes.string,
    tariffs: PropTypes.array
};

Internet.defaultProps = {
    pageContent: {},
    city: '',
    banner: {},
    tariffs: []
};

const mapStateToProps = state => ({
    cityDomain: state.city.currentCity.domain,
    banner: state.internet.banner,
    isAuth: state.auth.isAuth,
    cityIn: state.city.currentCity.cityIn,
    tariffs: state.internet.tariffs,
    questions: state.quiz.questions,
});

const mapDispatchToProps = dispatch => ({
    setTariffsForInternet: tariffs => dispatch(setTariffsForInternet(tariffs)),
    setBannerForInternet: bannerData => dispatch(setBannerForInternet(bannerData))
});

export default connect(mapStateToProps, mapDispatchToProps)(Internet);
